import type { TFunction } from "i18next";
import type { ReactNode } from "react";

export const NEW_SHEET_OPTION_ID = -1;

export function getDisplayValue(value: unknown, t: TFunction): ReactNode {
  if (value instanceof Date) return value.toLocaleDateString("pt-PT");
  if (typeof value === "boolean") return value ? t("generic.yes") : t("generic.no");
  if (value === null || value === undefined) return "-";
  if (typeof value === "string" || typeof value === "number") return value;
  return JSON.stringify(value);
}

export function getFieldKeys(key: string, value: unknown): string[] {
  if (!Array.isArray(value)) return [key];

  return value.flatMap((item, index) => {
    if (typeof item === "object" && item !== null) {
      return Object.keys(item).map((k) => `${key}.${index}.${k}`);
    }
    return [`${key}.${index}`];
  });
}

export function normalizeFieldValue(fieldName: string, raw: unknown, originalValue: unknown): unknown {
  if (fieldName === "name") {
    return raw === undefined ? originalValue ?? null : raw;
  }

  if (typeof originalValue === "boolean" || typeof raw === "boolean") {
    return !!raw;
  }

  if (raw === "" || raw === null || raw === undefined) {
    return null;
  }

  const num = Number(raw);
  return Number.isNaN(num) ? null : num;
}